<ion-header>
  <comp-header myText="{{ 'TITLE.support' | translate }}" [showMenuBtn]="true" [showBackBtn]="false"></comp-header>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-content>
      <div *ngIf="isPersian()" class="english">
        {{ 'CONTENT.Support.message' | translate}}
      </div>
      <div *ngIf="!isPersian()" class="persian">
        {{ 'CONTENT.Support.message' | translate}}
      </div>
      <ion-row>
        <a href="mailto:bayadictionary@gmail.com?Subject=Hello%20Baya" target="_top" style="color : black">Email :
          bayadictionary&#64;gmail.com</a>
      </ion-row>
      <ion-row>
        Telegram :
        <a href="https://telegram.me/tamasbabot?start={{information}}" target="_blank">
          <p>&#64;TamasBaBot</p>
        </a>
      </ion-row>
      <ion-row>
        Instagram :
        <a href="https://www.instagram.com/bayadic" target="_blank">
          <p>&#64;bayadic</p>
        </a>
      </ion-row>
    </ion-card-content>
  </ion-card>
</ion-content>